import { Overlay, Popover } from "react-bootstrap";
import { useRef, useState } from "react";

import { InfoOutlinedIcon } from "../../utils/components/icons";

const Tooltip = (props) => {
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const timeout = 10000;
  let t;

  if (!props.children) return null;

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target.parentNode);
    if (!show) {
      t = setTimeout(() => {
        setShow(false);
        t = null;
      }, timeout);
    } else {
      if (t) clearTimeout(t);
    }
  };

  return (
    <div className="d-inline-block" ref={ref}>
      <button
        type="button"
        className="btn-link"
        onClick={handleClick}
      >
        <InfoOutlinedIcon />
      </button>
      <Overlay
        show={show}
        target={target}
        placement="right"
        container={ref}
        containerPadding={20}
      >
        <Popover id="popover-contained">
          <Popover.Body className="f-small">
            {props.children}
          </Popover.Body>
        </Popover>
      </Overlay>
    </div>
  );
};

export default Tooltip;
